import { Button } from "components/general";
import * as React from "react";
import { Link } from "react-router-dom";
import { Routes } from "router";
import styles from "./styles.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";
import * as yup from "yup";

interface ContactData {
  firstName: string;
  lastName: string;
  message: string;
  email: string;
}

const initialValues: ContactData = {
  firstName: "",
  lastName: "",
  message: "",
  email: "",
};

const contactSchema = yup
  .object({
    message: yup.string().required("Required"),
    firstName: yup.string().required("Required"),
    lastName: yup.string().required("Required"),
    email: yup.string().email("Enter a valid email").required("Required"),
  })
  .required();

interface ContactUIProps {
  submit: (data: ContactData) => void;
  clearForm: boolean;
}

const ContactUI: React.FC<ContactUIProps> = ({ submit, clearForm }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ContactData>({
    resolver: yupResolver(contactSchema),
    defaultValues: initialValues,
  });

  const onSubmit: SubmitHandler<ContactData> = (data) => {
    submit(data);
  };

  React.useEffect(() => {
    reset();
  }, [clearForm]);

  return (
    <section id="contact" className={`container ${styles.contactContainer}`}>
      <p className={styles.tag}>Contact Us</p>
      <h1 className={styles.contactTtl}>Get in touch</h1>
      <p className={styles.contactTxt}>
        We'd love to hear from you, please fill the form
      </p>
      <form className={styles.contactForm}>
        <div className={`${styles.inputWrap} ${styles.halfWidth}`}>
          <label>First name</label>
          <input
            type={"text"}
            {...register("firstName", {
              required: true,
            })}
          />
          {errors.firstName?.message ? (
            <p className={styles.errorMessage}>{errors.firstName?.message}</p>
          ) : (
            ""
          )}
        </div>
        <div className={`${styles.inputWrap} ${styles.halfWidth}`}>
          <label>Last name</label>
          <input
            type={"text"}
            {...register("lastName", {
              required: true,
            })}
          />
          {errors.lastName?.message ? (
            <p className={styles.errorMessage}>{errors.lastName?.message}</p>
          ) : (
            ""
          )}
        </div>
        <div className={styles.inputWrap}>
          <label>Email Address</label>
          <input
            type={"email"}
            {...register("email", {
              required: true,
            })}
          />
          {errors.email?.message ? (
            <p className={styles.errorMessage}>{errors.email?.message}</p>
          ) : (
            ""
          )}
        </div>
        <div className={styles.inputWrap}>
          <label>Message</label>
          <textarea
            {...register("message", {
              required: true,
            })}
          />
          {errors.message?.message ? (
            <p className={styles.errorMessage}>{errors.message?.message}</p>
          ) : (
            ""
          )}
        </div>
        <Button
          className={styles.contactBtn}
          onClick={handleSubmit(onSubmit)}
        >
          Send Message
        </Button>
      </form>
      <div className={styles.regulatoryInfo}>
        <p className={styles.regulatoryTtl}>Regulatory Information</p>
        <p className={styles.regulatoryTxt}>
          Loan services on Zitra are provided by{" "}
          <strong>Zitra Microfinance Bank Ltd</strong>, licensed and regulated by
          the <strong>Central Bank of Nigeria (CBN)</strong>.
        </p>
        <p className={styles.regulatoryTxt}>
          Zitra Investments Ltd is a related entity registered as a Fund Manager
          by the Securities and Exchange Commission (SEC).
        </p>
        <Link to={Routes.privacy_policy} className={styles.privacyLink}>
          Loan Services Privacy Policy
        </Link>
      </div>
    </section>
  );
};

export { ContactUI };
export type { ContactData };
